import VideoThumbnail from "./videoThumbnail";

const VideoPreview = ({ videoThumbnails, videoTitle, credit, creditProps, children }) => (
    <div className="simple-video-preview">
        <figure>
            <span className="simple-video-preview__container">
                <span className="simple-video-preview__link">
                    {videoThumbnails && (
                        <VideoThumbnail
                            thumbnails={videoThumbnails}
                            videoTitle={videoTitle}
                        />
                    )}
                </span>
            </span>
            {credit && (
                <span className={creditProps.creditClassName}>
                    <span
                        className={creditProps.creditInnerClassName}
                        style={creditProps.creditInnerStyle}
                    >
                        {credit}
                    </span>
                </span>
            )}
            {children}
        </figure>
    </div>
);

export default VideoPreview;